var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7455 6.66666H17.4364H15.4727V4.66666C15.4727 4.29866 15.1802 4 14.8182 4H9.58182C9.21987 4 8.92728 4.29866 8.92728 4.66666V6.66666H6.96364H5.65454C5.29258 6.66666 5 6.96531 5 7.33331C5 7.70131 5.29255 8 5.65454 8H6.30907V18C6.30907 19.1027 7.19011 20 8.27272 20H16.1273C17.2099 20 18.0909 19.1027 18.0909 18V8H18.7455C19.1074 8 19.4 7.70134 19.4 7.33334C19.4 6.96534 19.1074 6.66666 18.7455 6.66666ZM10.2364 5.33334H14.1636V6.66669H10.2364V5.33334ZM16.7818 18C16.7818 18.3673 16.4886 18.6667 16.1273 18.6667H8.27272C7.91141 18.6667 7.61818 18.3673 7.61818 18V8H9.58182H14.8182H16.7819V18H16.7818Z",
    fill: "#757783"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2366 9.3335C9.87461 9.3335 9.58203 9.63215 9.58203 10.0002V16.0002C9.58203 16.3682 9.87461 16.6668 10.2366 16.6668C10.5985 16.6668 10.8911 16.3682 10.8911 16.0002V10.0002C10.8911 9.63215 10.5985 9.3335 10.2366 9.3335Z",
    fill: "#3A3C45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1638 9.3335C13.8019 9.3335 13.5093 9.63215 13.5093 10.0002V16.0002C13.5093 16.3682 13.8019 16.6668 14.1638 16.6668C14.5258 16.6668 14.8184 16.3682 14.8184 16.0002V10.0002C14.8184 9.63215 14.5258 9.3335 14.1638 9.3335Z",
    fill: "#3A3C45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrash);
export default __webpack_public_path__ + "static/media/ic-trash.a04abbfc3a3634168f4f143480639eb4.svg";
export { ForwardRef as ReactComponent };